export default __webpack_public_path__ + "static/media/github_icon.03f9853f.svg";